import type { CorvidSDKPropsFactory } from '@wix/editor-elements-types/corvid';
import { withValidation } from '../../validations';
import type { RoleSDKProps, RoleSDK } from './types';
import { assert } from '../../assert';

const roleSDKFactory: CorvidSDKPropsFactory<RoleSDKProps, RoleSDK> = ({
  setProps,
  props,
}) => ({
  get role() {
    return props.role;
  },

  set role(value) {
    setProps({
      role: assert.isNil(value) ? undefined : value,
    });
  },
});

export const createRoleSDK = withValidation(roleSDKFactory, {
  type: ['object'],
  properties: {
    role: {
      type: ['string'],
    },
  },
});
